<template>
    <div class="vue-onboarding__content v-step__content text-left">
        <div v-if="step.content" v-html="$t(step.content)"></div>
    </div>
</template>

<script>
export default {
    name: "vue-onboarding-content",

    props: {
        step: {
            type: Object,
            default: () => ({}),
        },
    },

    data() {
        return {};
    },
};
</script>

<style lang="scss">
.vue-onboarding__content {
    padding: 16px;
    margin-bottom: -5px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/VueOnboarding/VueOnboardingContent.vue